import type { ReactNode } from 'react';
import { UI_STRINGS } from '@/lib/constants/ui-strings';

function initialsOf(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .slice(0, 2)
    .join('');
}

interface SharedProfileIdentityHeaderProps {
  companyName: string;
  /** Small uppercase badge above the avatar (screen 2's "SECURE ACCESS" - omitted on screen 3). */
  badge?: ReactNode;
}

/**
 * "[Startup Name] has shared their Startup Profile with you" identity block -
 * shared by the email-verify and OTP-verify screens (MYN-58 screens 2 & 3).
 */
export function SharedProfileIdentityHeader({ companyName, badge }: SharedProfileIdentityHeaderProps) {
  return (
    <div className="flex flex-col items-center gap-3 text-center">
      {badge}
      <span
        aria-hidden="true"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-green font-sans text-lg font-semibold text-white"
      >
        {initialsOf(companyName)}
      </span>
      <div className="flex flex-col items-center gap-1">
        <h1 className="font-sans text-xl font-bold text-navy">{companyName}</h1>
        <p className="text-sm text-subtext">{UI_STRINGS.SHARED_PROFILE.SHARED_WITH_YOU}</p>
      </div>
    </div>
  );
}
